"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countCustomersCoachingDays = void 0;
exports.default = (customers, subscriptionType) => {
    return customers.filter((customer) => customer.subscriptionPeriod.periodType.typeId === subscriptionType).length;
};
const countCustomersCoachingDays = (customers) => {
    const days = {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
    };
    customers.forEach((customer) => {
        if (customer.subscriptionPeriod.periodType.typeId === "premium") {
            for (const day in days) {
                const dayIndex = parseInt(day);
                days[dayIndex] = days[dayIndex] + 1;
            }
            return;
        }
        Object.entries(days).forEach(([day, value]) => {
            if (customer.subscriptionPeriod.coachingDays.includes(parseInt(day))) {
                days[parseInt(day)] = value + 1;
            }
        });
    });
    return days;
};
exports.countCustomersCoachingDays = countCustomersCoachingDays;
//# sourceMappingURL=countCustomers.js.map